import React from 'react';
import styled, { css } from 'styled-components';
import { translate } from '../../../../common/translation/translate';
import { IForecastCard } from '../../common/types';

type HourCardConditionProps = Pick<IForecastCard, 'temperature' | 'precipitation'>

export const HourCardCondition = ({ temperature = '', precipitation = '' }: HourCardConditionProps) => {
    return (
        <Container>
            <TemperatureReading>
                {temperature}
            </TemperatureReading>
            <PrecipReading>
                {`${translate('precip')} ${precipitation}`}
            </PrecipReading>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 68px;
`;

const CommonInfoStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: #666;
    width: 100%;
`;

const TemperatureReading = styled.div`
    ${CommonInfoStyles}
    height: 25px;
    font-size: 20px;
    font-weight: 600;
`;

const PrecipReading = styled.div`
    ${CommonInfoStyles}
    height: 17px;
    font-size: 13px;
    font-weight: 400;
`;